import { ChangeDetectionStrategy, Component, OutputRef } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TextareaComponent } from '@libs/form/components';
import { TextareaInputModel } from '@libs/form/models';
import { ReferenceTextInputData } from './order-reference-text.model';

@Component({
  selector: 'ui-order-reference-text',
  templateUrl: './order-reference-text.component.html',
  styleUrl: './order-reference-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TextareaComponent,
    MatCardContent,
    MatCard,
  ],
})
export class OrderReferenceTextComponent {
  public dataAlias: TextareaInputModel = ReferenceTextInputData;
  public referenceTextResponseControl: FormControl<string> = new FormControl<string>('', { nonNullable: true });
  public textChanged: OutputRef<string> = outputFromObservable(this.referenceTextResponseControl.valueChanges);
}
